<template>
  <div class="dialog-container wt-dialog-container ">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" >
      <wt-form-table-list slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="garbageCount" slot-scope="data">
          <span>{{ $wtUtil.transWeight(data.row.garbageCount)}}</span>
        </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'SiteRecycleViewTab',
  isAutoComponent: true,
  props: ['siteId'],
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteDeliveryGarbageCountList', params: { siteId: '' }}
        },
        formInputsData: [],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/site/siteDeliveryGarbageCountListImport',
          fileName: '可回收物库存' }],
        formTableData: [
          { name: '物品名称', key: 'garbageName', type: 'text' },
          { name: '库存数量（kg）', key: 'garbageCount', type: 'custom' }],
        formTableButtonsData: [],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.siteId = this.siteId
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {}
  }
}
</script>
